import { SOMBRA_AUTHENTICATION_SCOPE_VERIFICATION_FAILED_ERROR_MESSAGE } from '@main/utils';

/**
 * Check if the error message is indicative of a Sombra scope error.
 * Implies user has logged with lower scopes than required.
 *
 * In such case, user should be prompted with login modal to re-login
 *
 * @param error - The error message
 * @returns True if the error message indicates a Sombra scope error
 */
export function isSombraScopeError(error: string): boolean {
  return [
    SOMBRA_AUTHENTICATION_SCOPE_VERIFICATION_FAILED_ERROR_MESSAGE,
    // add more error messages here if needed
  ].some((x) => error.includes(x));
}
